import { isFormValidated } from '../../../utils/formUtils';
import { useHistory } from 'react-router-dom';
import TermsAndConditions from './TermsAndConditions';

const TermsAndConditionsPage = () => {
  const history = useHistory();

  const saveTermsAccepted = (event: any) => {
    if (!isFormValidated('termsForm')) {
      return;
    }

    event.preventDefault();
    // Save the acceptance of terms in localStorage
    localStorage.setItem('termsAccepted', 'true');

    history.push('/entry');
  };

  return (
    <>
      <TermsAndConditions>
        <form className='mt-4' id='termsForm'>
          <div className='form-check'>
            <input type='checkbox' className='form-check-input me-2' id='termsCheckbox' required />
            <label htmlFor='termsCheckbox' className='form-check-label'>
              By checking this box you acknowledge that you have read, understood, and agree to be
              bound by these Terms and Conditions, including any future modifications
            </label>
          </div>
          <div className='mt-4'>
            <button onClick={saveTermsAccepted} className='btn btn-primary btn-lg col-md-3'>
              I accept
            </button>
          </div>
        </form>
      </TermsAndConditions>
    </>
  );
};
export default TermsAndConditionsPage;
